export default __webpack_public_path__ + "static/media/attract-loop.7ee45989.webm";